import { Suspense, lazy } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { LoadingComponent } from '../components'

function App() {
  return (
    <BrowserRouter>
      <Paging />
    </BrowserRouter>
  )
}

const Paging = () => {

  const HomePage = lazy(() => import('../pages/home/Home'))
  const PlacesPage = lazy(() => import('../pages/places'))

  return (
    <Suspense fallback={<LoadingComponent />}>
      <Routes>
        <Route path='/' element={<HomePage />} />
        <Route path='/places' element={<PlacesPage />} />
      </Routes>
    </Suspense>
  )
}

export default App;
